module.exports = __webpack_public_path__ + "static/media/sniplead.eda38962.png";